<script lang="ts" setup>
import type { StrapiParsedComponent } from '@autobid/strapi-integration/typescript/strapi/Page'
import { isComponentVisible } from '@autobid/strapi-integration/utils/isComponentVisible'
import { getGlobalComponent } from '@autobid/ui/utils/globalComponentsMap'
import { computed } from 'vue'

interface Props {
  component: StrapiParsedComponent
  componentName: string
  asSidebar?: boolean
  authenticated: boolean
  fallback?: boolean
  zIndex: number
}

const props = defineProps<Props>()

const resolvedComponent = computed(() => {
  const strapiName = `${props.componentName}${props.fallback ? 'Fallback' : ''}`

  const component = getGlobalComponent(strapiName)

  if (!component && process.dev) {
    console.log(`[DynamicComponent] NOT FOUND: "${strapiName}"`)
  }

  return component
})

const isVisible = computed(() => {
  if (!('configuration' in props.component.props)) {
    return true
  }

  return isComponentVisible(
    props.authenticated,
    props.component.props.configuration?.visability,
  )
})
</script>

<template>
  <component
    :is="resolvedComponent"
    v-if="isVisible && resolvedComponent"
    :data="component.props"
    :z-index="zIndex"
  />
</template>
